var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { PureComponent } from 'react';
import { defaultProps } from './defaults';
import { omit } from '../../Utils/object';
import { ClearOutlined } from '@feb-team/legao-icons-react';
import { DivTag, TextAreaTag, SpanTag } from '../../Utils/AtomicTag';
// 防止受控和非受控转换时报错
function fixControlledValue(value) {
    if (typeof value === 'undefined' || value === null) {
        return '';
    }
    return value;
}
var Textarea = /** @class */ (function (_super) {
    __extends(Textarea, _super);
    function Textarea(props) {
        var _this = _super.call(this, props) || this;
        _this.setValue = function (value, e, callback) {
            if (!('value' in _this.props)) {
                _this.setState({ value: value }, callback);
            }
            var onChange = _this.props.onChange;
            if (onChange) {
                var event_1 = e;
                onChange(value, event_1);
            }
        };
        _this.handleChange = function (e) {
            var clearable = _this.props.clearable;
            _this.setState({
                showClear: e.target.value.length > 0 && clearable,
            });
            _this.setValue(e.target.value, e);
        };
        // 清除
        _this.handleClear = function (e) {
            var that = _this;
            that.setState({
                value: '',
                showClear: false,
            }, function () {
                var onChange = that.props.onChange;
                if (onChange) {
                    //@ts-ignore
                    onChange('');
                }
            });
        };
        var value = typeof props.value === 'undefined' ? props.defaultValue : props.value;
        _this.state = {
            value: value,
            showClear: false,
        };
        return _this;
    }
    Textarea.getDerivedStateFromProps = function (nextProps) {
        if ('value' in nextProps) {
            return {
                value: nextProps.value,
            };
        }
        return null;
    };
    Textarea.prototype.render = function () {
        var _a = this.props, disabled = _a.disabled, className = _a.className, style = _a.style, clearable = _a.clearable, showCount = _a.showCount, maxLength = _a.maxLength;
        var _b = this.state, value = _b.value, showClear = _b.showClear;
        var textAreaBox = ['relative', 'w-px-200'];
        var textAreaClass = [
            'border',
            'border-solid',
            'border-gray-300',
            'w-full',
            'rounded',
            'leading-px-22',
            'pt-px-8',
            'pl-px-12',
            'pb-px-20',
        ];
        if (clearable) {
            textAreaClass.push('pr-px-30');
        }
        else {
            textAreaClass.push('pr-px-12');
        }
        // 文本框的禁用/启用样式
        if (disabled) {
            textAreaClass.push('cursor-not-allowed', 'hover:border-gray-300', 'text-gray-400', 'bg-gray-100');
        }
        else {
            textAreaClass.push('hover:border-brand-600', 'focus:border-brand-600', 'text-gray-700', 'focus:shadow-input');
        }
        var clearInputClass = [
            'absolute',
            'right-0',
            'left-auto',
            'top-auto',
            'w-px-16',
            'h-px-16',
            'cursor-pointer',
            'text-gray-200',
            'mr-px-10',
            'mt-px-10',
            'text-sm',
            'leading-none',
        ];
        showClear ? clearInputClass.push('visible') : clearInputClass.push('invisible');
        var countCls = ['text-gray-400', 'text-right', 'text-xs', '-mt-px-5'];
        var otherProps = omit(this.props, [
            'leftAddon',
            'rightAddon',
            'onBeforeEnter',
            'onEnter',
            'defaultValue',
            'clearable',
            'searchText',
            'className',
            'style',
            'showCount',
        ]);
        return (React.createElement(DivTag, { name: Textarea.NAME, atomics: textAreaBox, className: className, style: style },
            React.createElement(TextAreaTag, __assign({}, otherProps, { value: fixControlledValue(value), atomics: textAreaClass, disabled: disabled, onChange: this.handleChange })),
            clearable && (React.createElement(SpanTag, { atomics: clearInputClass },
                React.createElement(ClearOutlined, { onClick: this.handleClear }))),
            showCount && (React.createElement(DivTag, { atomics: countCls, autoPrefixedClassName: "textarea-count" },
                value ? (React.createElement(SpanTag, { atomics: "text-brand-600" }, value.length)) : (React.createElement(SpanTag, null, "0")),
                React.createElement("span", null,
                    "/",
                    maxLength)))));
    };
    Textarea.defaultProps = defaultProps;
    Textarea.NAME = 'textarea';
    Textarea.displayName = 'Textarea';
    return Textarea;
}(PureComponent));
export { Textarea };
